import React, { useState } from 'react';
import { Box, Notification, NotificationType } from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';

import { StyledBold } from './SuccessPageNotification.style';

interface SuccessPageNotificationProps {
  variant: 'benefits' | 'merchant' | 'unfinished';
  numberOfEmployees?: number;
}

export const SuccessPageNotification = ({
  variant,
  numberOfEmployees
}: SuccessPageNotificationProps) => {
  const { t } = useTranslation();
  const [showNotification, setShowNotification] = useState(true);

  const notificationConfig = {
    benefits: {
      type: NotificationType.Success,
      defaults: t('components.onboarding.success_page.notifications.benefits', {
        numberOfEmployees
      })
    },
    merchant: {
      type: NotificationType.Info,
      defaults: t('components.onboarding.success_page.notifications.merchant')
    },
    unfinished: {
      type: NotificationType.Important,
      defaults: t('components.onboarding.success_page.notifications.unfinished')
    }
  };

  if (!showNotification) {
    return null;
  }

  return (
    <Box>
      <Notification
        type={notificationConfig[variant].type}
        text={
          <Trans
            i18nKey={notificationConfig[variant].defaults}
            components={{ bold: <StyledBold /> }}
          />
        }
        onClose={() => {
          setShowNotification(false);
        }}
        id={`onboarding-success_page-notification-${variant}`}
      />
    </Box>
  );
};
